import type { BasicCustomMailRequiredItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductPlanFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	atCreated: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtCreatedForText: (value: string) => void;
	onSetAtCreatedForOverride: (value: boolean) => void;
	atUpdated: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtUpdatedForText: (value: string) => void;
	onSetAtUpdatedForOverride: (value: boolean) => void;
	atCanceled: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtCanceledForText: (value: string) => void;
	onSetAtCanceledForOverride: (value: boolean) => void;
	hotelEmailAddress: string;
	lang: LangCode;
	handleClickedSendTestEmailReservationCreated: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	handleClickedSendTestEmailReservationUpdated: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	handleClickedSendTestEmailReservationCanceled: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;

	/** 基本メール設定の文言 */
	basicCustomMailSetting: ProductPlanFormModel["QueryData"]["basicCustomMailSetting"];

	title?: string;
	guide?: string;
};

export const ForTriggerReservationEmailTemplates = ({
	isEdited,
	hasError,
	atCreated,
	onSetAtCreatedForText,
	onSetAtCreatedForOverride,
	atUpdated,
	onSetAtUpdatedForText,
	onSetAtUpdatedForOverride,
	atCanceled,
	onSetAtCanceledForText,
	onSetAtCanceledForOverride,
	hotelEmailAddress,
	lang,
	handleClickedSendTestEmailReservationCreated,
	handleClickedSendTestEmailReservationUpdated,
	handleClickedSendTestEmailReservationCanceled,
	basicCustomMailSetting,

	title: _title,
	guide: _guide,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約成立時"}
						dialogTitle={"予約成立時"}
						textValue={atCreated?.text.value}
						overrideValue={atCreated?.override.value}
						shouldSendEmail={true}
						textErrorMessage={atCreated?.text.error}
						overrideErrorMessage={atCreated?.override.error}
						shouldSendEmailErrorMessage={undefined}
						handleChangeText={onSetAtCreatedForText}
						handleChangeOverride={onSetAtCreatedForOverride}
						sendTestEmail={handleClickedSendTestEmailReservationCreated}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCreated?.override.value}
						onOverrideModeChange={onSetAtCreatedForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCreated}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約が変更された時"}
						dialogTitle="予約変更時"
						textValue={atUpdated?.text.value}
						overrideValue={atUpdated?.override.value}
						shouldSendEmail={true}
						textErrorMessage={atUpdated?.text.error}
						overrideErrorMessage={atUpdated?.override.error}
						shouldSendEmailErrorMessage={undefined}
						handleChangeText={onSetAtUpdatedForText}
						handleChangeOverride={onSetAtUpdatedForOverride}
						sendTestEmail={handleClickedSendTestEmailReservationUpdated}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atUpdated?.override.value}
						onOverrideModeChange={onSetAtUpdatedForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atUpdated}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約がキャンセルされた時"}
						dialogTitle="予約キャンセル時"
						textValue={atCanceled?.text.value}
						overrideValue={atCanceled?.override.value}
						shouldSendEmail={true}
						textErrorMessage={atCanceled?.text.error}
						overrideErrorMessage={atCanceled?.override.error}
						shouldSendEmailErrorMessage={undefined}
						handleChangeText={onSetAtCanceledForText}
						handleChangeOverride={onSetAtCanceledForOverride}
						sendTestEmail={handleClickedSendTestEmailReservationCanceled}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCanceled?.override.value}
						onOverrideModeChange={onSetAtCanceledForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCanceled}
					/>
				</div>
			}
		/>
	);
};

ForTriggerReservationEmailTemplates.displayName = "ForTriggerReservationEmailTemplates";
